module.exports = __webpack_public_path__ + "static/media/2022-Q4-Market_Analysis_Services_Update.ddcb1289.htm";